module.exports = __webpack_public_path__ + "media/img/home/our-work/photo-2-hover-e769853cb346af66ad3924ef6f5031dc.webp";